import React, { type FC, type PropsWithChildren } from 'react';

type EllipsisProps = {
  /** The color of the ellipsis icon */
  color?: string;
};

const Ellipsis: FC<PropsWithChildren<EllipsisProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="4" viewBox="0 0 28 4" width="28" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="2" fill={color} r="2" />
    <circle cx="14" cy="2" fill={color} r="2" />
    <circle cx="26" cy="2" fill={color} r="2" />
  </svg>
);

export default Ellipsis;
